import 'jquery-validation';

$(function () {
	if (!$('#partner-program-form').length) return;

	var $form = $('#partner-program-form');
	var $tabs = $('.sp-form-step-tab');
	var $panes = $('.sp-form-step-pane');
	var $prevBtn = $('#partnerProgramPrevBtn');
	var $nextBtn = $('#partnerProgramNextBtn');
	var $submitBtn = $('#partnerProgramSubmitBtn');
	var $stepCount = $('#partnerProgramStepCount');
	var currentStep = 1;
	var totalSteps = 3;

	var stepFields = {
		1: ['cegnev', 'adoszam', 'weboldal', 'kapcsolattarto_nev', 'kapcsolattarto_tel', 'kapcsolattarto_email'],
		2: ['ertekesitett_termekek', 'latogatottsag', 'egyuttmukodes'],
		3: []
	};

	function renderStepCount(step) {
		var template = window.Lang.partner_stepcount || ':current/:total';
		var text = template
			.replace(':current', String(step))
			.replace(':total', String(totalSteps));
		$stepCount.text(text);
	}

	function syncSummary() {
		$form.find('[data-summary-for]').each(function () {
			var $target = $(this);
			var sourceName = $target.data('summaryFor');
			var $source = $form.find('[name="' + sourceName + '"]');
			$target.val(($source.val() || '').toString().trim());
		});
	}

	function showStep(step) {
		currentStep = Math.max(1, Math.min(totalSteps, step));

		$panes.removeClass('active');
		$panes.filter('[data-step="' + currentStep + '"]').addClass('active');

		$tabs.removeClass('active');
		$tabs.filter('[data-step="' + currentStep + '"]').addClass('active');

		$prevBtn.toggle(currentStep > 1);
		$nextBtn.toggle(currentStep < totalSteps);
		$submitBtn.toggle(currentStep === totalSteps);

		if (currentStep === totalSteps) {
			syncSummary();
		}

		renderStepCount(currentStep);
	}

	var validator = $form.validate({
		rules: {
			cegnev: { required: true },
			adoszam: { required: true },
			weboldal: { required: true, url: true },
				kapcsolattarto_nev: { required: true },
				kapcsolattarto_tel: { required: true },
				kapcsolattarto_email: { required: true, email: true },
			ertekesitett_termekek: { required: true },
			latogatottsag: { required: true },
			egyuttmukodes: { required: true }
		},
		messages: {
			cegnev: { required: window.Lang.partner_val_required || window.Lang.val_name_required },
			adoszam: { required: window.Lang.partner_val_required || window.Lang.val_name_required },
			weboldal: {
				required: window.Lang.partner_val_required || window.Lang.val_name_required,
				url: window.Lang.partner_val_url || window.Lang.val_email_invalid
			},
				kapcsolattarto_nev: { required: window.Lang.partner_val_required || window.Lang.val_name_required },
				kapcsolattarto_tel: { required: window.Lang.partner_val_required || window.Lang.val_name_required },
				kapcsolattarto_email: {
					required: window.Lang.val_email_required,
					email: window.Lang.val_email_invalid
				},
			ertekesitett_termekek: { required: window.Lang.partner_val_required || window.Lang.val_name_required },
			latogatottsag: { required: window.Lang.partner_val_required || window.Lang.val_name_required },
			egyuttmukodes: { required: window.Lang.partner_val_required || window.Lang.val_name_required }
		},
		errorElement: 'label',
		errorClass: 'error',
		errorPlacement: function (error, element) {
			error.insertAfter(element.closest('.sp-form-field'));
		},
		highlight: function (element) {
			$(element).closest('.sp-form-field-group').addClass('has-error');
		},
		unhighlight: function (element) {
			$(element).closest('.sp-form-field-group').removeClass('has-error');
		},
		submitHandler: function (form) {
			var $btn = $submitBtn;
			$btn.prop('disabled', true);

			$.ajax({
				url: $form.attr('action'),
				method: 'POST',
				data: $form.serialize(),
				dataType: 'json',
				success: function (res) {
					if (res.status === 'success' && res.redirect) {
						window.location.href = res.redirect;
						return;
					}

					GlobalSwal.fire({
						title: window.Lang.error_title,
						text: res.msg || res.message || window.Lang.partner_submit_error,
						icon: 'error',
						confirmButtonText: window.Lang.confirm_button
					});
					$btn.prop('disabled', false);
				},
				error: function (xhr) {
					var errors = xhr.responseJSON && xhr.responseJSON.errors;
					if (errors) {
						var msg = Object.values(errors).flat().join('\n');
						GlobalSwal.fire({
							title: window.Lang.error_title,
							text: msg,
							icon: 'error',
							confirmButtonText: window.Lang.confirm_button
						});
					} else {
						GlobalSwal.fire({
							title: window.Lang.error_title,
							text: window.Lang.partner_submit_error,
							icon: 'error',
							confirmButtonText: window.Lang.confirm_button
						});
					}
					$btn.prop('disabled', false);
				}
			});
		}
	});

	function validateCurrentStep() {
		var valid = true;
		(stepFields[currentStep] || []).forEach(function (field) {
			var $field = $form.find('[name="' + field + '"]');
			if ($field.length && !validator.element($field)) {
				valid = false;
			}
		});
		return valid;
	}

	$nextBtn.on('click', function () {
		if (!validateCurrentStep()) return;
		showStep(currentStep + 1);
	});

	$prevBtn.on('click', function () {
		showStep(currentStep - 1);
	});

	$tabs.on('click', function () {
		var target = parseInt($(this).data('step'), 10);
		if (!target || target === currentStep) return;

		if (target > currentStep) {
			for (var s = currentStep; s < target; s += 1) {
				currentStep = s;
				if (!validateCurrentStep()) {
					showStep(s);
					return;
				}
			}
		}

		showStep(target);
	});

	showStep(1);
});
